import React, { useEffect, useState } from "react";
import { Divider, Form, Select, Radio } from "antd";
import GenericDialog from "../../common/GenericDialog";
import axios, {prepareAxiosParamsForStruts} from "../../common/axios";

const ShareTrailDialog = (props) => {
    const { open, onClose, tasksName, taskName, selectedTrails } = props;
    const [shareTeachers, setShareTeachers] = useState([]);
    const [selectedTeacherIds, setSelectedTeacherIds] = useState([]);
    const [shareAssessmentForm] = Form.useForm();
    const [selectedShareOption, setSelectedShareOption] = useState('Teacher');

    useEffect(() => {
        axios.get('/controlCentre/getSchoolsTeachers.action')
            .then(response => {
                if (response.data) {
                    setShareTeachers(response.data);
                }
            }).catch((error) => {
            console.error('Error loading school\'s teachers: ', error);
        });
    }, [open]);

    const handleTeacherChange = (value) => {
        setSelectedTeacherIds(value);
    };

    const shareTrail = async () => {
        const pathwayIds = Array.from(selectedTrails.values()).map(obj => obj.pathwayId);
        let params;

        if(selectedShareOption === 'School') {
            params = {
                pathwayIds: pathwayIds,
                shareType: 'SCHOOL'
            };
        }
        if(selectedShareOption === 'Teacher'){
            params = {
                pathwayIds: pathwayIds,
                shareType: 'USER',
                teacherIds: selectedTeacherIds
            };
        }

        await axios.post('/trail/shareTrail.action', prepareAxiosParamsForStruts(params), {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            if (response.data) {
                if(response.data.success){
                    displayToastMessage(`Success`, response.data.message, 'success', 5000 + ((response.data.length - 5) * 1000));
                } else {
                    displayToastMessage('Error', 'Error sharing the tasks/s', 'error', 10000);
                }
            } else {
                displayToastMessage('Error sharing, please contact the website admin', '', 'error', 10000);
            }
        }).catch((error) => {
            console.error(error);
        }).finally(() => {
            onClose();
        });
    }

    const getTaskName = () => {
        if(selectedTrails.size > 1){
            return tasksName.toLowerCase();
        } else {
            return taskName.toLowerCase();
        }
    }

    return (
        <GenericDialog
            title={`Share ${selectedTrails.size > 1 ? tasksName : taskName}`}
            open={open}
            onClose={onClose}
            buttons={[
                {
                    name: 'Cancel',
                    extraProps: { type: 'text' },
                },
                {
                    name: 'Share',
                    callback: shareTrail
                },
            ]}
        >
            <Radio.Group
                buttonStyle={'solid'}
                onChange={(e) => setSelectedShareOption(e.target.value)}
                value={selectedShareOption}
            >
                <Radio.Button value="Teacher">Teachers</Radio.Button>
                <Radio.Button value="School">Whole School</Radio.Button>
            </Radio.Group>
            <Divider />
            {selectedShareOption === 'Teacher' &&
                <>
                    <p style={{ minWidth: '300px', maxWidth: '400px' }}>
                        Click or search for a teacher's name to share the {getTaskName()} with them. Multiple teachers can be selected.
                        The other teacher can then manage and assign the {getTaskName()}.
                    </p>
                    <Divider />
                    <Form
                        className="testFamilyForm"
                        name="shareAssessment"
                        form={shareAssessmentForm}
                    >
                        <Form.Item
                            label="Teachers"
                            name="teacherIds"
                            rules={[
                                {
                                    required: true,
                                    message: 'Select at least one teacher.',
                                },
                            ]}
                        >
                            <Select
                                style={{ minWidth: '300px', maxWidth: '300px'}}
                                virtual={false}
                                showSearch={true}
                                filterOption={(input, option) =>
                                    option.label?.toLowerCase().includes(input.toLowerCase())
                                }
                                allowClear
                                autoClearSearchValue={true}
                                mode="multiple"
                                onChange={handleTeacherChange}
                            >
                                {shareTeachers?.map((teacher) => (
                                    <Select.Option
                                        key={teacher.userId}
                                        value={teacher.userId}
                                        label={`${teacher.firstName} ${teacher.lastName}`}
                                    >
                                        {teacher.firstName + ' ' + teacher.lastName}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Form>
                </>
            }
            {selectedShareOption === 'School' &&
                <>
                    <p style={{minWidth: '300px', maxWidth: '400px'}}>
                        The {getTaskName()} will be shared with your entire school.
                    </p>
                </>
            }
        </GenericDialog>
    );
};

export default ShareTrailDialog;
